import React from 'react';
interface ProgressBarProps {
  progress: number;
}
export function ProgressBar({
  progress
}: ProgressBarProps) {
  return <div className="w-full h-3 bg-gray-200 rounded-full overflow-hidden" data-id="element-117">
      <div className="h-full bg-gradient-to-r from-[#19EAC4] to-[#052858] relative" style={{
      width: `${progress}%`
    }} data-id="element-118">
        <div className="absolute inset-0 bg-white opacity-20 animate-shimmer" data-id="element-119" />
      </div>
    </div>;
}